// @flow

import Enum from './Enum';

export const IncludeTypeEnums = new Enum({
    SalesCategory: 'SALES_CATEGORY',
    SalesCategories: 'SALES_CATEGORIES',
    Shift: 'SHIFT',
    Shifts: 'SHIFTS',
    Contact: 'CONTACT',
    Transporter: 'TRANSPORTER',
    RiderPersona: 'RIDER_PERSONA',
    Rider: 'RIDER',
    VehicleModel: 'VEHICLE_MODEL',
    BusinessUnit: 'BUSINESS_UNIT',
    FleetModels: 'FLEET_MODELS',
    PrimaryFleetEntities: 'PRIMARY_FLEET_ENTITIES',
    SecondaryFleetEntities: 'SECONDARY_FLEET_ENTITIES',
    CrossDock: 'CROSS_DOCK_INFO',
    Preferences: 'PREFERENCES',
    IncludeAuth: 'includeAuth',
    IncludeRole: 'includeRole',
    Homebase: 'HOMEBASE',
    Location: 'LOCATION',
    Sku: 'SKU',
    LotrAppInfo: 'LOTR_APP_INFO'
});
